export default {
    bgMain: "#1B1B22",
    bgLayout: "#1a1b22",
    texttMain: "#ffffff",
    textSecundary: "#8A8A8E",
    textBlack: "#1B1B22",
    bgLogin: "#b7b7b9",
    borderGray: "#5E5E63",
    bgInput: "#26262e",
    borderInput: "#545458",
    bgHover: "#2b2a32",
    bgOpacity: "#33333b",
    bgButtonWhite: "#ffffff",
    bgButtonBlack: '#26262c',
    textBlackButton: '#13131A',
    graywhite: '#e4e4e4',
    errorBorder: '#e4847f',
    bgDiv: '#26262D',


}